/*
 * @Description:
 * @Date: 2022-01-28 15:44:01
 */
const getters = {
  // token: state => state.user.token,
  // avatar: state => state.user.avatar,
  // name: state => state.user.name,
  // introduction: state => state.user.introduction,
  // status: state => state.user.status,
  // roles: state => state.user.roles,
  // setting: state => state.user.setting,
  permission_routers: state => state.permission && state.permission.routers,
  addRouters: state => state.permission && state.permission.addRouters,
  getMenusList: state => state.aside && state.aside.menusList,
  getMenusListRoles: state => state.aside && state.aside.menusRoles,
  getButton: state => state.aside && state.aside.buttonList,
  isMaster: state =>
    state.user.user && +state.user.user['isMainAccountNumber'] === 1,
  projectStructureType: state => +state.homeProject.projectStructureType,
  executorNamed: state => {
    let map = [null, '自然人', '经营者', '经营者'];
    return map[+state.homeProject.projectStructureType];
  },
  executeBody: state => {
    return [2, 3].includes(+state.homeProject.userEnterpriseType)
      ? '个体'
      : '自然人';
  },
  isGeti: state => {
    const userEnterpriseType = +state.homeProject.userEnterpriseType;
    return [2, 3].includes(+userEnterpriseType);
  },
  isPark: state => {
    const userEnterpriseType = +state.homeProject.userEnterpriseType;
    return +userEnterpriseType === 3;
  },
  projectInfo: state => state.homeProject,
  hasPayRule: state => state.user.user.isPayRule === 1
};
export default getters;
